import React, { useEffect, useRef } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";

import ProjectView from "../../pages/ProjectView";
const ProjectPreview = ({ show, setShow, previewData }) => {
  const modalRef = useRef(null);

  const handleClose = () => {
    setShow(false);
  };
  useOutsideClick(modalRef, handleClose, null, show);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);
  return (
    <div className="w-full z-50 flex justify-center items-center fixed left-0 right-0 top-0 bottom-0 popup-bg ">

      <div
        className="w-[95%] relative h-[85%] flex justify-center max-h-[1400px] "
        ref={modalRef}
      >

        <ProjectView
          previewData={previewData}
          isPreview={true}
          handleClosePreview={handleClose}
        />
      </div>
    </div>
  );
};

export default ProjectPreview;
